<template>
  <base-legal-page
    kicker="Devprompt"
    title="Devprompt - Support"
  >
    <p>We're here to help you get the most out of Devprompt.</p>

    <h2>About Devprompt</h2>
    <p>
      Devprompt is a knowledge app for software developers. Hundreds of questions across languages, systems, cloud and AI, each written to be learned rather than looked up: one line you can keep, a sentence you can say out loud, plain terms when the jargon is in the way, then the depth and the code underneath.
    </p>

    <h2>Frequently Asked Questions</h2>

    <p><strong>Does it work offline?</strong></p>
    <p>
      Yes. The whole library ships inside the app, so everything works with no connection and nothing is downloaded after you install it.
    </p>

    <p><strong>How often is new content added?</strong></p>
    <p>
      New content arrives roughly every month. Because the library is part of the app, you receive it with the next app update from the App Store.
    </p>

    <p><strong>What does the purchase include?</strong></p>
    <p>
      One purchase unlocks the entire library permanently, including categories added later. There is no subscription and nothing recurring.
    </p>

    <p><strong>I bought it before and reinstalled. How do I get it back?</strong></p>
    <p>
      Open the unlock screen and tap "Restore purchases." Apple will confirm the purchase on your account and the library will unlock again. Make sure you are signed in with the same Apple Account you bought it with.
    </p>

    <p><strong>Is my progress saved anywhere?</strong></p>
    <p>
      Your progress, streak and settings are stored on your device only. They are never uploaded, which also means they are not carried across to a new device and are removed if you delete the app.
    </p>

    <p><strong>What do "Learn" and "Trends" mean?</strong></p>
    <p>
      Learn is the library itself, browsable by category. Trends is what is changing in the industry and what to do about it — each entry is dated, so you can see how recent the assessment is and weigh it accordingly.
    </p>

    <p><strong>How do I see the intro again?</strong></p>
    <p>
      Open About from the home screen and tap "Replay the intro."
    </p>

    <p><strong>I think an answer is wrong.</strong></p>
    <p>
      Please tell us, and include the question title. Accuracy matters more to us than volume, and corrections ship with the next content update.
    </p>

    <p><strong>The app is crashing or not working properly. What should I do?</strong></p>
    <p>Please try the following steps:</p>
    <ul>
      <li>Make sure you have the latest version of the app installed</li>
      <li>Restart the app</li>
      <li>Restart your device</li>
    </ul>
    <p>
      If the issue persists, contact us below and include your device model, your iOS version, and the version and build number shown on the About screen.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you need further assistance or have any questions, feedback, or concerns, please reach out to us:
    </p>
    <div class="hh-legal__contact">
      <div><strong>Email:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Website:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'DevpromptSupport',

    metaInfo: { title: 'Devprompt Support' },
  }
</script>
